import script from "./PgmNoticeWrite.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmNoticeWrite.vue?vue&type=script&setup=true&lang=ts"

import "./PgmNoticeWrite.vue?vue&type=style&index=0&id=06c15df8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06c15df8"]])

export default __exports__